export default class AgentCategory {

    constructor(jsonObj) {

        this.id = jsonObj["id"];
        this.category = jsonObj["category"];
        this.amount = jsonObj["amount"];
        this.categoryIconUrl = jsonObj["category-icon-url"];
        this.categoryBodyUrl = jsonObj["category-body-url"]

    }

}